import { formatCurrency } from 'helpers';

export interface CurrencyConfig {
  code: string;
  symbol: string;
  locale: string;
  fractionDigits: number;
}

// Na razie hardcode PLN — gotowe do podmiany na dane z backendu
const DEFAULT_CURRENCY: CurrencyConfig = {
  code: 'PLN',
  symbol: 'zł',
  locale: 'pl-PL',
  fractionDigits: 2,
};

export interface UseCurrencyReturn {
  currency: CurrencyConfig;
  format: (value: number) => string;
  formatWithSymbol: (value: number) => string;
}

export const useCurrency = (
  override?: Partial<CurrencyConfig>,
): UseCurrencyReturn => {
  // TODO: zastąpić pobraną walutą z backendu/store gdy będzie dostępna
  const currency: CurrencyConfig = { ...DEFAULT_CURRENCY, ...override };

  const format = (value: number): string =>
    formatCurrency(value, currency.locale, currency.fractionDigits);

  const formatWithSymbol = (value: number): string =>
    `${format(value)} ${currency.symbol}`;

  return { currency, format, formatWithSymbol };
};
